import React from 'react'
import ReactDOM from 'react-dom/client'
import { applyAideProductMode } from '@aide/ui'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/global.css'

applyAideProductMode('forge')

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
